import React from 'React';
import { replaceAssetsURL } from '../../helpers/helpers';

const ContentImage = ({featured_image, title}) => (<figure className="contentimage container">
    <img src={replaceAssetsURL(featured_image, '?w=1000')} alt={title} />
</figure>);

export default ContentImage;